// extracted by extract-css-chunks-webpack-plugin
module.exports = {"role":"person-role__role--3MPl-","type":"person-role__type--3zh7E","btn":"person-role__btn--SvJEF"};